import React from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'

type Props = {
  handleloginModal?: () => void
}

const Hero = ({handleloginModal}: Props) => {
  return (
    <div className='row'>
      <div className='col-xl-9'>
        <div className='card card-xl-stretch mb-5 mb-xl-0  bg-card-gradient'>
          <div className='card-body d-flex flex-column flex-lg-row flex-stack p-lg-15'>
            <div className='d-flex flex-column justify-content-center align-items-center align-items-lg-start me-10 text-center text-lg-start'>
              <h3 className=' line-height-lg mb-5  '>
                <span className='fw-bold h2-mktg fw-bolder text-gradient-pink-blue'>Create your profile.</span>
                <br />
                <span className='fw-bold h2-sktg text-white'>and start working on remote jobs</span>
              </h3>

              <div className='fs-4   mb-7 fw-bold text-white    opacity-75'>
                We match a developer's skills to US based projects
              </div>
              <button
                onClick={handleloginModal}
                className='btn btn-success fw-bold px-6 py-3 btn-hover-scale'
                data-bs-toggle='modal'
              >
                Join as a developer{' '}
                <KTSVG
                  path='/media/icons/duotune/arrows/arr024.svg'
                  className='svg-icon-2 svg-icon-success  ms-2'
                />
              </button>
              <div>
                <span>
                  <span className=' text-white  opacity-90'>Are you a recruiter?{' '}</span>
                  <Link to='/contact' className='btn btn-link text-white text-underlined '>
                   <u> Contact us</u>
                  </Link>
                </span>
              </div>
            </div>

            <img
              src='/media/svg/illustrations/easy/5.svg'
              alt=''
              className='mw-200px mw-lg-350px mt-lg-n10'
            />
          </div>
        </div>
        <div className='mt-20'>
          <span className='fw-bolder fs-6 '>
            Join hundreds of companies that trust Lucian to hire remote software developers
          </span>
          <div className='d-flex'>
            <KTSVG
              path='/media/svg/brand-logos/adidas-9.svg'
              className='svg-icon-3x svg-icon-primary  mx-3'
            />
            <KTSVG
              path='/media/svg/brand-logos/asml-1.svg'
              className='svg-icon-5x svg-icon-primary  mx-3'
            />
            <KTSVG
              path='/media/svg/brand-logos/deloitte-1.svg'
              className='svg-icon-5x svg-icon-primary  mx-3'
            />
            <KTSVG
              path='/media/svg/brand-logos/farmers-insurance-3.svg'
              className='svg-icon-5x svg-icon-primary  mx-3'
            />
            <KTSVG
              path='/media/svg/brand-logos/verizon-2015.svg'
              className='svg-icon-5x svg-icon-primary  mx-3'
            />
          </div>
        </div>
      </div>
      <div className='col-xl-3'>
        
        <div className='card border-0 shadow-none ' style={{backgroundColor: '#63b6e58c'}}>
          <div className='card-body '>
            <div className=' mb-1 text-center d-flex flex-column flex-center pb-0 pt-15'>
              <h3 className='mb-2 fw-boldest text-center text-uppercase'>Create you CV</h3>
              <p className='text-center opacity-30 fw-bold'>
                You can use our CV creation tool to organize your portfolio
              </p>

              <div className='mb-7 text-center justify-content-center row-column'>
                <div className='d-flex align-items-center mb-2'>
                  <span className='svg-icon svg-icon-4 svg-icon-white opacity-75 me-3'>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr001.svg'
                      className='svg-icon-2 svg-icon-primary  ms-2'
                    />
                  </span>

                  <span className='opacity-75'> Highligt your skills</span>
                </div>

                <div className='d-flex align-items-center mb-2'>
                  <span className='svg-icon svg-icon-4 svg-icon-white opacity-75 me-3'>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr001.svg'
                      className='svg-icon-2 svg-icon-primary  ms-2'
                    />
                  </span>

                  <span className='opacity-75'>Organised and simple</span>
                </div>

                <div className='d-flex align-items-center mb-2'>
                  <span className='svg-icon svg-icon-4 svg-icon-white opacity-75 me-3'>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr001.svg'
                      className='svg-icon-2 svg-icon-primary  ms-2'
                    />
                  </span>

                  <span className='opacity-75'>Exportable</span>
                </div>
              </div>

              <button
                onClick={handleloginModal}
                className='btn btn-hover-rise bg-white bg-dark text-white text-uppercase fs-7 fw-bolder align-self-center'
              >
                Get started now
              </button>
            </div>

            <img
              alt='sigma'
              className='mw-100 h-225px mx-auto mb-n14 d-flex align-items-center'
              src='/media/illustrations/sigma-1/12.png'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
